export default __webpack_public_path__ + "static/fiona-064e2ebc1eb478e5ee43d89ebe4fe99c.jpg";